import { render, staticRenderFns } from "./VSuggest.vue?vue&type=template&id=4041c245"
import script from "./VSuggest.vue?vue&type=script&lang=js"
export * from "./VSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports